import { Box, Divider, Typography, makeStyles } from '@material-ui/core';

import { AuthConnectionsSection } from './AuthConnectionsSection';
import { CreateWorkspaceFooter } from './CreateWorkspaceFooter';
import { RegionSection } from './RegionSection';
import { WorkspaceNameFields } from './WorkspaceNameFields';
import type { CreateAccountFormState } from './hooks';

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: '100%',
    maxWidth: 480,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(6),
  },
}));

type WorkspaceSetupFormProps = {
  form: CreateAccountFormState;
};

export const WorkspaceSetupForm = ({ form }: WorkspaceSetupFormProps) => {
  const classes = useStyles();

  return (
    <Box
      height="100%"
      width="100%"
      overflow="auto"
      display="flex"
      justifyContent="center"
    >
      <div className={classes.wrapper}>
        <Box marginBottom={4} textAlign="center">
          <Typography variant="h4" gutterBottom>
            Set up your workspace
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Choose your workspace name carefully. It can't be changed later.
          </Typography>
        </Box>

        <WorkspaceNameFields form={form} />

        {form.showAuthConnections && (
          <>
            <Box marginY={4}>
              <Divider />
            </Box>
            <AuthConnectionsSection form={form} />
          </>
        )}

        <Box marginY={4}>
          <Divider />
        </Box>
        <RegionSection form={form} />

        <Box marginY={4}>
          <Divider />
        </Box>
        <CreateWorkspaceFooter form={form} />
      </div>
    </Box>
  );
};
